<template>
    <div>
        <input id="input-box" type="text" v-model="value" readonly/>
    </div>
</template>

<script>
    export default {
        name: "ResultBox",
        props: ['getValue'],
        // 计算属性
        computed: {
            value() {
                return this.getValue
            },
        },
    }
</script>

<style scoped>

    #input-box {
        display: block;
        width: 100%;
        height: 46px;
        margin-bottom: 15px;
        border:none;
        border-radius: 2px;
        background: #77baa2;
        box-shadow: 0 4px #21bd86 inset;
        padding: 0 5px;
        text-align: right;
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
    }
</style>
